module.exports = __webpack_public_path__ + "static/favicon-1f451f36e435a1bd5f391f668a074496.ico";